import { queryMembers } from "@wix/ambassador-members-v1-member/http";
import DataLoader from "dataloader";
import { POLL_TYPE } from "./../../wix-rich-content-common";
import { PollsService } from "./PollsService";
const isSSR = () => typeof window === "undefined";
const fetchMembers = (membersIds, instance, getHttpClientPromise) => getHttpClientPromise().then((httpClientInstance) => {
  const membersPromise = httpClientInstance.request(queryMembers({ query: { filter: { id: { $in: membersIds } } } }), {
    signedInstance: instance
  }).then((res) => {
    if (res.status === 200) {
      return res?.data?.members || [];
    } else {
      throw res.statusText;
    }
  }).catch((e) => {
    console.error("[pollsStrategy] fetchMembers failed. error:", e);
    return [];
  }).then(normalizeMembers);
  return membersPromise;
});
const membersCache = /* @__PURE__ */ new Map();
function createMembersLoader(loadMembers) {
  return new DataLoader(
    (memberIds) => {
      return loadMembers(memberIds).then(
        (memberList) => memberIds.map(
          (id) => memberList.find((m) => m.siteMemberId === id) || new Error("Member not found")
        )
      );
    },
    { cacheMap: membersCache }
  );
}
const normalizeMembers = (rawMembers) => rawMembers?.map?.((member) => {
  return {
    siteMemberId: member.id ?? void 0,
    imageUrl: member.profile?.photo?.url ?? void 0,
    name: {
      nick: member.profile?.nickname ?? void 0
    }
  };
});
function pollsStrategy(instance, getHttpClientPromise) {
  if (!instance) {
    return {};
  }
  const getSiteMembers = isSSR() ? void 0 : (() => {
    const loader = createMembersLoader(async (memberIds) => {
      const members = await fetchMembers(memberIds, instance, getHttpClientPromise);
      return memberIds.map(
        (id) => members.find((m) => m.siteMemberId === id) || {
          // We fallback to private member if member not found, or we have fetch error for now.
          siteMemberId: id
        }
      );
    });
    return loader.loadMany.bind(loader);
  })();
  return {
    config: {
      [POLL_TYPE]: {
        pollServiceApi: new PollsService(instance, getHttpClientPromise),
        siteToken: instance,
        getSiteMembers
      }
    }
  };
}
export {
  pollsStrategy as default
};
//# sourceMappingURL=pollsStrategy.js.map
